import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  useMediaQuery,
} from "@mui/material";
import NertzRiver from "./nertz/NertzRiver";
import NertzPile from "./nertz/NertzPile";
import NertzHand from "./nertz/NertzHand";
import NertzWorkPiles from "./nertz/NertzWorkPiles";
import NertzScoreboard from "./nertz/NertzScoreboard";
import { useNavigate, useParams } from "react-router-dom";
import { MeApi } from "../api/MeApi";
import {
  Hand,
  Game,
  Deck,
  NertzGameApi,
  Pile,
  River,
  Work,
  MeReady,
  MeStuck,
  MePaused,
  OtherPaused,
  nertzPlayerMessage,
  NertzCaller,
  NertzWinner,
  AllReady,
  Stuck,
  NertzQuitter,
  StuckCount,
} from "../api/NertzApi";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { useEffect, useState } from "react";
import { CardHeight, getDeck } from "../api/CardApi";
import {
  CancelTwoTone,
  CheckTwoTone,
  LogoutTwoTone,
  UndoTwoTone,
} from "@mui/icons-material";

function Nertz() {
  const params = useParams(),
    nav = useNavigate(),
    [game, setGame] = useRecoilState(Game),
    meReady = useRecoilValue(MeReady),
    allReady = useRecoilValue(AllReady),
    meStuck = useRecoilValue(MeStuck),
    mePaused = useRecoilValue(MePaused),
    otherPaused = useRecoilValue(OtherPaused),
    setStuck = useSetRecoilState(Stuck),
    setStuckCount = useSetRecoilState(StuckCount),
    isXL = useMediaQuery("(min-height:1536px)"),
    isLG = useMediaQuery("(min-height:1200px)"),
    isMD = useMediaQuery("(min-height:900px)"),
    isSM = useMediaQuery("(min-height:600px)"),
    isXS = useMediaQuery("(min-height:0px)"),
    setCardHeight = useSetRecoilState(CardHeight),
    setRiver = useSetRecoilState(River),
    setPile = useSetRecoilState(Pile),
    setWork = useSetRecoilState(Work),
    setDeck = useSetRecoilState(Deck),
    setHand = useSetRecoilState(Hand),
    [caller, setCaller] = useRecoilState(NertzCaller),
    [quitter, setQuitter] = useRecoilState(NertzQuitter),
    [winner, setWinner] = useRecoilState(NertzWinner),
    [busy, setBusy] = useState(false);

  useEffect(() => {
    if (isXL) {
      setCardHeight(250);
    } else if (isLG) {
      setCardHeight(200);
    } else if (isMD) {
      setCardHeight(160);
    } else if (isSM) {
      setCardHeight(128);
    } else if (isXS) {
      setCardHeight(102);
    }
  }, [isXL, isLG, isMD, isSM, isXS, setCardHeight]);

  return (
    <Stack id="nertz-board" sx={{ height: 1 }} spacing={2}>
      <MeApi />
      <NertzGameApi {...params} />

      <Box sx={{ flexGrow: 1 }} />

      <NertzRiver />

      <Stack id="nertz-board-row-stack" direction="row" spacing={2}>
        <Box style={{ flexGrow: 1 }} />
        <Stack spacing={2}>
          <NertzPile />
          <NertzHand />
        </Stack>
        <NertzWorkPiles />
        <NertzScoreboard />
        <Box style={{ flexGrow: 1 }} />
      </Stack>

      <Box sx={{ flexGrow: 1 }} />

      <Dialog open={!meReady}>
        <DialogTitle>Let's Make a Deal</DialogTitle>
        <DialogContent>
          Deal your cards when you are ready to begin.
        </DialogContent>
        <DialogActions>
          <Button
            disabled={busy}
            startIcon={<CheckTwoTone />}
            variant="contained"
            onClick={() => {
              setBusy(true);

              const deck = getDeck();

              setStuck(false);
              setStuckCount(0);
              setRiver(Array.from({ length: game.players.length * 4 }));
              setPile(deck.slice(0, 13));
              setWork(deck.slice(13, 17).map((c) => [c]));
              setDeck(deck.slice(17));
              setHand([]);

              nertzPlayerMessage(params.id, {
                player: { isReady: true },
              }).then(setBusy(false));
            }}
          >
            Deal
          </Button>
          <Button
            onClick={() => {
              nertzPlayerMessage(params.id, { quit: true });
              nav(-1);
            }}
            startIcon={<CancelTwoTone />}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={meReady && !allReady}>
        <DialogTitle>Slackers not Ready</DialogTitle>
        <DialogContent>
          Waiting on other players. Don't look away!
        </DialogContent>
      </Dialog>

      <Dialog open={meStuck}>
        <DialogTitle>Got them Ole Stuck Nertz Blues</DialogTitle>
        <DialogContent>
          Fear not! We'll let you know when you can play again.
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              nertzPlayerMessage(params.id, {
                player: { isStuck: false },
              });
              setStuck(false);
            }}
            startIcon={<UndoTwoTone />}
            variant="contained"
          >
            Nevermind
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={mePaused}>
        <DialogTitle>Game Paused</DialogTitle>
        <DialogContent>
          Just let us know when you are ready, Your Highness.
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              nertzPlayerMessage(params.id, {
                player: { isPaused: false },
              });
            }}
            variant="contained"
          >
            I'm Back
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={otherPaused}>
        <DialogTitle>Game Paused</DialogTitle>
        <DialogContent>
          Someone has paused the game. Don't you hate that?
        </DialogContent>
      </Dialog>

      <Dialog open={!!caller} fullWidth maxWidth="sm">
        <DialogTitle>
          {game && game.players
            ? `${
                game.players.find((p) => p.id === caller)?.username
              } Called Nertz!`
            : ""}
        </DialogTitle>
        <DialogContent>
          <NertzScoreboard raised={false} />
        </DialogContent>
        <DialogActions>
          <Button
            startIcon={<CheckTwoTone />}
            variant="contained"
            onClick={() => {
              setCaller(null);
              setGame({
                ...game,
                ...{
                  players: game.players.map((p) => ({
                    ...p,
                    ...{ isReady: false, isStuck: false },
                  })),
                },
              });
              if (meStuck) {
                setStuck(false);
              }
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={!!winner} fullWidth maxWidth="sm">
        <DialogTitle>
          {game && game.players
            ? `${game.players.find((p) => p.id === winner)?.username} Wins!`
            : ""}
        </DialogTitle>
        <DialogContent>
          <NertzScoreboard raised={false} />
        </DialogContent>
        <DialogActions>
          <Button
            startIcon={<CheckTwoTone />}
            variant="contained"
            onClick={() => {
              setWinner(null);
              setGame({
                ...game,
                ...{
                  players: game.players.map((p) => ({
                    ...p,
                    ...{
                      isPaused: false,
                      isReady: false,
                      isStuck: false,
                      nertz: 0,
                      score: 0,
                      scores: [],
                    },
                  })),
                },
              });
              if (meStuck) {
                setStuck(false);
              }
            }}
          >
            Play Again
          </Button>
          <Button
            startIcon={<CancelTwoTone />}
            onClick={() => {
              nertzPlayerMessage(params.id, { quit: true });
              nav(-1);
            }}
          >
            I'm Out
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={!!quitter}>
        <DialogTitle>
          {game && game.players
            ? `${game.players.find((p) => p.id === quitter)?.username} has Quit`
            : ""}
        </DialogTitle>
        <DialogContent>You must be pretty intimidating.</DialogContent>
        <DialogActions>
          <Button
            startIcon={<LogoutTwoTone />}
            variant="contained"
            onClick={() => {
              setQuitter(null);
              nav(-1);
            }}
          >
            Leave
          </Button>
        </DialogActions>
      </Dialog>
    </Stack>
  );
}

export default Nertz;
